module.exports = __webpack_public_path__ + "img/qrcode.3d7a6d1b.png";